import { render, staticRenderFns } from "./PartnerOkPopup.vue?vue&type=template&id=53577ba2&"
import script from "./PartnerOkPopup.vue?vue&type=script&lang=js&"
export * from "./PartnerOkPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports